export function reorderFavorites(favorites, fromIndex, toIndex) {
  if (!Array.isArray(favorites)) return [];
  if (fromIndex === toIndex) return [...favorites];
  if (fromIndex < 0 || toIndex < 0) return [...favorites];
  if (fromIndex >= favorites.length || toIndex >= favorites.length) {
    return [...favorites];
  }

  const nextFavorites = [...favorites];
  const [movedFavorite] = nextFavorites.splice(fromIndex, 1);
  nextFavorites.splice(toIndex, 0, movedFavorite);
  return nextFavorites;
}

export function normalizeFavoritesForPersistence(
  currentFavorites,
  nextFavorites,
) {
  if (!Array.isArray(currentFavorites) || !Array.isArray(nextFavorites)) {
    return Array.isArray(currentFavorites) ? [...currentFavorites] : [];
  }

  const ordered = nextFavorites.filter((favorite) =>
    currentFavorites.includes(favorite),
  );
  const missing = currentFavorites.filter(
    (favorite) => !ordered.includes(favorite),
  );
  return [...ordered, ...missing];
}
